import * as SiteAPI from '@/api/site';

export default {
  data() {
    return {
      // 所属客户
      stationList: [],
      currentStation: null,
    };
  },

  methods: {
    // 获取当前客户所有站点列表
    getAllSiteList(customerId) {
      const params = {};
      if (customerId) {
        params.customerId = customerId;
      }
      return SiteAPI.SiteSelect(params).then(res => {
        if (res.code === 0) {
          this.stationList = res.data || [];
        }
        return res;
      });
    },
  },
};
